import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CoachPage } from '@pages/coaches/coach';
import { CoachVideoPage } from '@pages/coaches/CoachVideoPage';
import { EventArchivePage } from '@pages/events/event-archive/ui.tsx';
import { EventBuy } from '@pages/events/event-buy';
import { EventClient } from '@pages/events/event-client';
import { EditorPage } from '@pages/events/event-editor';
import { EventMain } from '@pages/events/event-main';
import { EventPage } from '@pages/events/event-page';
import { TicketsPage } from '@pages/events/event-ticket';
import { VisitorPage } from '@pages/events/event-visitor';
import { EventVisitors } from '@pages/events/event-visitors';
import { PublicationPage } from '@pages/events/publication-page';
import { SelectGroup } from '@pages/events/select-group';
import { useLoadGroups } from '@src/features/common';
import { Container } from 'library/components/ui';
import { useShare } from 'library/hooks/events';
import { ModalEventShare } from './frames';

const Events: React.FC = () => {
  const share = useShare();
  useLoadGroups();

  return (
    <>
      {share.isOpen && <ModalEventShare />}
      <Routes>
        <Route path=":code">
          <Route index element={<EventMain />} />
          <Route path="archive" element={<EventArchivePage />} />
          <Route
            path="create"
            element={
              <>
                <EditorPage />
              </>
            }
          />
          {/*<Route path="create/select-tag" element={<ModulesTagsPage />} />*/}
          <Route path="create/select-group" element={<SelectGroup />} />
          <Route path=":id">
            <Route index element={<EventPage />} />
            <Route
              path="edit"
              element={
                <Container style={{ position: 'relative' }}>
                  <EditorPage />
                </Container>
              }
            />
            <Route path="specialist/:coachId" element={<CoachPage />} />
            <Route path="specialists/:coachId/:coachVideoId" element={<CoachVideoPage />} />
            {/*<Route path="edit/select-tag" element={<ModulesTagsPage />} />*/}
            <Route path="edit/select-group" element={<SelectGroup />} />
            <Route
              path="buy"
              element={
                <Container style={{ position: 'relative' }}>
                  <EventBuy />
                </Container>
              }
            />

            <Route
              path="tickets"
              element={
                <Container style={{ position: 'relative' }}>
                  <TicketsPage />
                </Container>
              }
            />

            <Route path="visitors" element={<EventVisitors />} />
            <Route path="visitors/:visitorId" element={<VisitorPage />} />
            <Route path="publication" element={<PublicationPage />} />
          </Route>
          <Route path="client/:clientId" element={<EventClient />} />
        </Route>
      </Routes>
    </>
  );
};

export default Events;
